"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = require("./Button");
exports.default = Button_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Button/index.js
// module id = 70
// module chunks = 8